import gql from 'graphql-tag';

import userFragment, { shortUserFragment, userFragmentQuery } from './user-fragment';

export default gql`
  query findByIdUserQuery($_id: MongoID!) {
    findByIdUserQuery(_id: $_id) {
      ...UserFragment
    }
  }
  ${userFragment}
`;
